export default __webpack_public_path__ + "static/media/logo.a44763db.svg";